import { v4 as uuidv4 } from "uuid";

import Notice01Image01 from "../assets/images/notice/notice01/Notice01Image01.webp";
import Notice01Image02 from "../assets/images/notice/notice01/Notice01Image02.webp";
import Notice01Image03 from "../assets/images/notice/notice01/Notice01Image03.webp";
import Notice01Image04 from "../assets/images/notice/notice01/Notice01Image04.webp";
import Notice01Image05 from "../assets/images/notice/notice01/Notice01Image05.webp";
import Notice01Image06 from "../assets/images/notice/notice01/Notice01Image06.webp";

import Notice02Image01 from "../assets/images/notice/notice02/Notice02Image01.webp";
import Notice02Image02 from "../assets/images/notice/notice02/Notice02Image02.webp";

import Notice03Image01 from "../assets/images/notice/notice03/Notice03Image01.webp";
import Notice03Image02 from "../assets/images/notice/notice03/Notice03Image02.webp";

import Notice04Image01 from "../assets/images/notice/notice04/Notice04Image01.webp";
import Notice04Image02 from "../assets/images/notice/notice04/Notice04Image02.webp";

import Notice05Image01 from "../assets/images/notice/notice05/Notice05Image01.webp";
import Notice05Image02 from "../assets/images/notice/notice05/Notice05Image02.webp";

import Notice06Image01 from "../assets/images/notice/notice06/Notice06Image01.webp";

import Notice07Image01 from "../assets/images/notice/notice07/Notice07Image01.webp";

import Notice08Image01 from "../assets/images/notice/notice08/Notice08Image01.webp";
import Notice08Image02 from "../assets/images/notice/notice08/Notice08Image02.webp";
import Notice08Image03 from "../assets/images/notice/notice08/Notice08Image03.webp";

import Notice09Image01 from "../assets/images/notice/notice09/Notice09Image01.webp";
import Notice09Image02 from "../assets/images/notice/notice09/Notice09Image02.webp";

import Notice10Image01 from "../assets/images/notice/notice10/Notice10Image01.webp";
import Notice10Image02 from "../assets/images/notice/notice10/Notice10Image02.webp";
import Notice10Image03 from "../assets/images/notice/notice10/Notice10Image03.webp";

import Notice11Image01 from "../assets/images/notice/notice11/Notice11Image01.webp";

import Notice12Image01 from "../assets/images/notice/notice12/Notice12Image01.webp";

import Notice13Image01 from "../assets/images/notice/notice13/Notice13Image01.png";
import Notice13Image02 from "../assets/images/notice/notice13/Notice13Image01.png";

// S ::::: 공지사항 ::::: S
export const noticeLists = [
  {
    id: "13",
    title: "📢 IPDIA 국제실용댄스지도자협회 남양주지부 오픈 안내",
    date: "2026-07-23",
    listText:
      "IPDIA 국제실용댄스지도자협회 남양주 지부로 리버스댄스하우스가 새롭게 오픈되었습니다",
    detailText: `
   📢 IPDIA 국제실용댄스지도자협회 남양주지부 오픈 안내

IPDIA 국제실용댄스지도자협회 남양주 지부로 
리버스댄스하우스가 새롭게 오픈되었습니다

남양주지부 [리버스댄스하우스]는
IPDIA 본 협회 및 서울 본부센터인 
[넵튠 댄스스튜디오]와 협력하여,
체계적이고 수준높은 수업 퀄리티와 
다양한 활동으로 찾아뵙겠습니다 


📍 남양주 지부 INFO 
▶ 리버스댄스하우스 @re.shuffler
✶주소 : 경기도 남양주시 경춘로490 1동 B1층 1129호 
✶ 전화/문자 : 010-2751-2342
💬 카카오톡 검색 : @리버스댄스하우스

새롭게 시작하는 IPDIA 남양주 지부에
많은 관심과 응원 부탁드립니다.
감사합니다.
    `,
    images: [Notice13Image01, Notice13Image02],
  },
  {
    id: "12",
    title: "[2026 IPDIA 작품 세미나]",
    date: "2026-06-10",
    listText:
      "국제실용댄스지도자협회 전문자격증 취득자 대상 <2026 IPDIA 작품세미나>가 진행됩니다",
    detailText: `
   [2026 IPDIA 작품 세미나]

국제실용댄스지도자협회 전문자격증 취득자 대상
<2026 IPDIA 작품세미나>가 진행됩니다

소속 지도자 분들에게 유익한 시간이 될 예정이니
많은 관심 부탁드리며, 
자세한 내용은 아래를 참고해주세요 


• 일시:
2026.07.17 금요일
12:00 PM -4:00 PM

• 대상:
IPDIA 소속 강사 , 전문 자격증 취득자

• 내용:
난이도에 따른 레벨별 작품 및 가이드 제공 
세미나를 통한 안무가와의 교류 및 네트워킹 


[서울 본부센터 INFO]
▪️전화/문자 : 010-2351-8784, 010-7620-8784
▪️카카오톡 : @넵튠댄스스튜디오
▪️IPDIA 서울본부 넵튠 댄스 스튜디오
    `,
    images: [Notice12Image01],
  },
  {
    id: "11",
    title: "[VLAZE SHUFFLE WORKSHOP IN 대전]",
    date: "2026-04-02",
    listText: "[VLAZE SHUFFLE WORKSHOP IN 대전]",
    detailText: `
   [4월 20일 월요일 7시]
블레이즈 협회장님의 워크샵이 
대전에서 진행됩니다.

이번 특별 셔플 워크샵은
새단장한 국제실용댄스지도자협회 대전지부인
[투비셔플] 에서 진행됩니다.
서울이 멀어 참여가 어려우셨던 분들도
직접 경험할 수 있는 좋은 기회입니다.


[VLAZE 셔플 워크샵 정보]
•시간 :
4월 20일 (월) 7:00 ~ 8:00 PM

•장소 :
투비셔플 (IPDIA 대전지부)

•수업 내용 :
-> 기초응용을 이용한 원데이 셔플 루틴
-> 풋워크 디테일 및 스킬

[서울 본부센터 INFO]
▪️주소 : 서울 동작구 사당로16길 28 3층
▪️전화/문자 : 010-2351-8784, 010-7620-8784
▪️카카오톡 검색 : 넵튠댄스스튜디오

[대전지부 INFO]
▪️주소 : 대전 유성구 은구비남로 41 502호
▪️전화/문자 : 010-5828-5559
▪️카카오톡 검색 : 투비셔플
    `,
    images: [Notice11Image01],
  },

  {
    id: "10",
    title: "📌[셔플댄스 지도자 자격증 2급 3기 모집]",
    date: "2026-02-28",
    listText: "   IPDIA 국제실용댄스지도자협회의 셔플댄스 지도자 자격증 과정은",
    detailText: `
   IPDIA 국제실용댄스지도자협회의
셔플댄스 지도자 자격증 과정은

체계적인 교육 시스템과
실무 커리어가 뛰어난 강사진과의 트레이닝을 통해
전문인으로 성장할 수 있는 기회입니다.
⠀
현장에 도움 되는 실전 중심의 교육과정을 통해
차별화된 경쟁력을 지금 얻어가시길 바랍니다.
⠀

📅 모집 기간 : 2월 28일 ~ 3월 28일
⏳ 교육 일정 : 4월 4일 개강 (매주 토요일 / 3:00-6:00PM)


[추천 대상]
▪ 댄스 강사 자격증 취득을 희망하는 분
▪ 전문적인 트레이닝을 통해 셔플댄스 실력 극성장을 꿈꾸는 분
▪ 실무 중심의 교육으로 댄스 커리어를 확장하고 싶은 분
⠀

[신청 대상]
▪ IPDIA 본부 [넵튠] 또는 [지부] 10개월 이상 수강자 우선 선발
▪ 셔플댄스 1년 이상 경력 보유자
▪ 타 댄스 자격증 소지자 또는 댄스 관련 직업인 
※ 서류 심사 후 합격자는 교육 과정 합류 가능
⠀

[2급 교육 과정]
▪ 기간 : 9주
▪ 과정 : 교육 이수 후 자격 검정 응시 가능


[문의 및 신청]
▪ 전화/문자 : 010-2351-8784, 010-7620-8784
▪ IPDIA 서울본부 넵튠 댄스 스튜디오
▪ 카카오톡 : @넵튠댄스스튜디오
    `,
    images: [Notice10Image01, Notice10Image02, Notice10Image03],
  },
  {
    id: "9",
    title: "🔊IPDIA 국제실용댄스지도자협회 경기광주 지부 오픈 안내",
    date: "2026-02-24",
    listText:
      "IPDIA 국제실용댄스지도자협회 경기 광주 지부로 버닝댄스스튜디오 [BURNING DANCE STUDIO]가 새롭게 오픈되었습니다.",
    detailText: `
   IPDIA 국제실용댄스지도자협회 경기 광주 지부로
버닝댄스스튜디오 [BURNING DANCE STUDIO]가
새롭게 오픈되었습니다.

경기 광주 지부 [버닝댄스스튜디오]는
IPDIA 본 협회 및 서울 본부 센터인
[넵튠 댄스스튜디오]와 협력하여,
보다 체계적이고 수준 높은 수업 퀄리티와
다양한 활동으로 찾아뵙겠습니다.

📢 경기 광주 지부 INFO
▶︎ 버닝댄스스튜디오 [BURNING DANCE STUDIO]
✶ 주소 : 경기 광주시 고산길 17-2, 2층 201호
☎ 전화/문자 : 010-8823-4794
💬 카카오톡 검색 : 버닝댄스스튜디오

앞으로 IPDIA 경기 광주 지부에
많은 관심과 따뜻한 응원 부탁드립니다.
감사합니다.
    `,
    images: [Notice09Image01, Notice09Image02],
  },
  {
    id: "8",
    title: "📌 [케이팝 댄스 지도자 자격증 2급 과정 모집]",
    date: "2026-01-22",
    listText:
      "IPDIA 국제실용댄스지도자협회의 📌[K-POP 댄스 지도자 자격증 과정]",
    detailText: `
    IPDIA 국제실용댄스지도자협회의
📌[K-POP 댄스 지도자 자격증 과정]은

실제 업계 커리어가 뛰어난 전문 댄서 강사진과 함께하는
실전 중심의 트레이닝으로 댄스 강사를 꿈꾸는 분들 뿐만 아니라,

춤 실력을 성장시키고 심도 깊은 트레이닝을 경험하고 싶은 분들에게
매우 특화되어 있는 프로그램입니다.

지금 차별화된 경쟁력을 갖춘 지도자로 성장해보세요.


📚 1기 단체 교육 코스
▪ 교육 일정 : 3월 8일 개강
▪ 모집 기간 : 1월 22일 ~ 3월 2일
▪ 8주 커리큘럼
▪ 매주 일요일 3:00-5:00 PM

📘개인 교육 코스
▪정규 일정 참여가 어려운 분들을 위한
1:1 교육으로 자격 취득이 가능한 코스입니다
⠀

[추천 대상]
▪ 댄스 강사 자격증 취득을 희망하는 분
▪ 전문적인 트레이닝을 통해 댄스 실력 극성장을 원하는 분
▪ 실무 중심의 교육과 함께 춤을 확장하고 싶은 분

[신청 대상]
▪ IPDIA 본부센터 또는 지부 수업 8개월 이상 수강자 우선 선발
▪ IPDIA 전문 자격증 소지자
▪ 타 댄스 자격증 소지자 또는 댄스 1년 이상 경력
※ 서류 심사 후 합격자는 교육 과정 합류 가능
⠀
[2급 교육 과정]
▪ 기간 : 8주
▪ 과정 : 교육 이수 후 자격 검정 응시 가능
    `,
    images: [Notice08Image01, Notice08Image02, Notice08Image03],
  },
  {
    id: "7",
    title: "📌[셔플댄스 지도자 자격증 1급 1기 모집]",
    date: "2025-12-17",
    listText:
      "IPDIA 국제실용댄스지도자협회 📌[셔플댄스 지도자 자격증 1급 1기 모집]",
    detailText: `
    IPDIA 국제실용댄스지도자협회
📌[셔플댄스 지도자 자격증 1급 1기 모집]

IPDIA 셔플댄스 지도자 자격증 1급 1기 과정은
검증된 실력을 갖춘 전문 풋워크 · 셔플 댄서 강사진이
직접 교육을 진행하는 IPDIA의 최상위 지도자 양성 프로그램입니다.

본 과정은 단순한 이론 전달이나 형식적인 자격 부여에 그치지 않고,
현장 중심의 고난도 커리큘럼과 실무 밀착 트레이닝을 통해
실질적인 지도 역량과 전문성을 완성하는 데 초점을 둡니다.

체계적으로 설계된 교육 과정과 1급 자격증 취득을 통해
차별화된 경쟁력을 갖춘 전문 강사·교육자로의 도약을 지금 경험해보세요.


📅 모집 기간 : 12월 17일 ~ 1월 3일
⏳ 교육 일정 : 1월 10일 개강 (매주 토요일 / 시간 별도 공지)
🔎 문의 및 신청
* 전화/문자 : 010-2351-8784, 010-7620-8784
* 카카오톡 : @넵튠댄스스튜디오
* IPDIA 서울본부 넵튠 댄스 스튜디오


[추천 대상]
▪ 댄스 강사 자격증 취득을 희망하는 분
▪한층 깊은 주제와 고난도의 전문 트레이닝을 기대하는 분
▪실전 중심 교육으로 실력 향상과 폭 넓은 경험을 목표하는 분

[신청 대상]
▪ IPDIA 전문자격증 취득자 우선 선발
▪ 본부센터 레벨4 (마스터 단계) 1년 이상 수강자
▪ 본부센터 수강 중인 타 자격증 소지 및 댄스 직업인

※ PDIA 전문자격증 취득자를 우선으로 선발하며,
 추가 정원은 대상 기준이 되는 분들에 한해 심사 후
교육 과정에 합류하실 수 있습니다.

[1급 교육 과정]
▪ 기간 : 9주 커리럼
▪ 과정 : 교육 이수 후 자격 검정 응시 가능

    `,
    images: [Notice07Image01],
  },
  {
    id: "6",
    title: "【2025 FOOTWORKSHOP Vol.1 공연 안내】",
    date: "2025-11-22",
    listText:
      "IPDIA KOREA 서울본부센터 넵튠댄스스튜디오에서 2025년 12월 6일(토) 연말 공식 행사 **[Footworkshop Vol.1]**을 개최합니다.",
    detailText: `
    IPDIA KOREA 서울본부센터 넵튠댄스스튜디오에서
    2025년 12월 6일(토) 연말 공식 행사
    **[Footworkshop Vol.1]**을 개최합니다.

    본 공연은 한 해 동안 넵튠과 함께해주신 수강생 및 교육생분들,
    그리고 풋워크 문화를 사랑하는 모든 분들이
    함께 즐기고 교류할 수 있는 자리로 마련되었습니다.

    다양한 무대와 이벤트, 감사 선물이 준비되어 있으니
    여러분의 많은 참여 부탁드립니다.


    🔹티켓 구매 신청 안내

    아래 방법을 통해 입금 후
    **[성함 / 연락처 / 티켓 수량]**을
    기재하여 신청해주시기 바랍니다.

    1. 카카오톡 채널 : 넵튠댄스스튜디오
    https://pf.kakao.com/_xdxcJZn

    2. 전화 / 문자 문의
    010-2351-8784


    🎟️ 관람 티켓 안내
    • 티켓 금액 : 20,000원

    📅 공연 일정
    • 2025년 12월 6일(토)
    14:00 ~ 16:00
    ※티켓박스 오픈 : 13:30※

    📍 공연 장소
    송해아트홀
    (구로역 · 신도림역 인근)

    *Poster Design: @w.w.one
    `,
    images: [Notice06Image01],
  },
  {
    id: "5",
    title: "【IPDIA 전문자격증 취득자 대상 역량강화 워크샵 안내】",
    date: "2025-07-06",
    listText:
      "[국제실용댄스지도자협회 전문자격증 취득자] 대상 2025년도 역량강화 워크샵을 진행합니다.",
    detailText: `
   [국제실용댄스지도자협회 전문자격증 취득자] 대상
2025년도 역량강화 워크샵을 진행합니다.

✔️일시: 2025.08.02 토요일 10:30 am -3:30 pm
✔️대상: IPDIA 전문 자격증 취득자
✔️ [총 3개의 핵심 트레이닝 세션 & 5시간 프로그램]

1️⃣심화된 주제와 전문 강사진의
트레이닝으로 구성되는 3가지 핵심 세션


2️⃣참여자 간의 지식 교류 및 네트워킹

3️⃣강의 및 춤에 대한 고충 해소와 동작 집중 교정 솔루션등
참여를 통해 실질적인 성장과 인사이트를 
얻을 수 있는 특별 워크샵으로

ipdia 전문자격증을 취득하신 분들은 
이번 프라이빗 워크샵을 통해 직접적인 실력향상과 많은 인사이트를 
얻어가시기 바랍니다. 


🔍
전문자격증과정 문의 : 010-7620-8784
워크샵 참가 신청 문의 : 010-2351-8784
    `,
    images: [Notice05Image01, Notice05Image02],
  },
  {
    id: "4",
    title: "🔊IPDIA KOREA 국제실용댄스지도자협회 대전지부 오픈 안내 ",
    date: "2025-03-16",
    detailText: `
   🔊IPDIA KOREA 국제실용댄스지도자협회 대전지부 오픈 안내 

IPDIA KOREA 대전 지부
투비셔플 [TOBE SHUFFLE]이 설립되었습니다.

본 대전 지부, [투비셔플]은
국제실용댄스지도자협회 IPDIA KOREA ,
그리고 IPDIA KOREA의 서울 본부 센터 [넵튠 댄스스튜디오]와 협력하여,
보다 수준 높은 수업퀄리티와 활동으로 찾아뵙겠습니다.


ℹ 대전지부 INFO 
 투비셔플 [TOBE SHUFFLE]
▪ 주소 : 대전 유성구 은구비남로 41 502호
▪ 전화/문자 : 010-5828-5559
▪ 카카오톡 검색 : 투비셔플 


앞으로 대전 지부에 많은 관심과 응원 부탁드립니다.
감사합니다.
`,
    images: [Notice04Image01, Notice04Image02],
  },
  {
    id: "3",
    title: "『IPDIA KOREA 대전지부 오픈 기념 행사』",
    date: "2025-03-07",
    detailText: `
    안녕하세요.
    IPDIA KOREA 국제실용댄스지도자협회입니다.
    
    IPDIA KOREA의 대전지부 오픈 기념으로
    오픈식과 더불어 특별 워크샵을 진행합니다.
    
    자세한 정보는 아래를 참고해주세요.
    
    ══
    
    [대전지부 투비셔플 오픈식 & 특별 워크샵]
    📅3월 25일 화요일
    🚩투비셔플 - 대전 유성구 은구비남로 41 502호
    🔗신청방법 - https://forms.gle/Vj8qvc5Um1d6WRyg9
    🔍
    워크샵 문의 : 010-2351-8784
    오픈식 문의 : 010-5828-5559
    
    ▬ 오픈식
    투비셔플 TOBE SUFFLE
    ▪시간 : 6:00 pm
    ▪티켓비 : FREE
    
    ▬ VLAZE 특별 워크샵
    🏛️【𝗪𝗢𝗥𝗞𝗦𝗛𝗢𝗣 𝟭 | 셔플 비기너】
    ▪시간 : 7:00-8:00pm
    ▪수강료 : 40,000원
    ▪셔플 기초스텝을 배우고 계신 분들을 위한 셔플안무 수업
    
    🏛️【𝗪𝗢𝗥𝗞𝗦𝗛𝗢𝗣 𝟮 | 셔플&풋워크 레벨업】
    ▪시간 : 8:00-9:00pm
    ▪수강료 : 40,000원
    ▪셔플 6개월 이상의 경험자분들을 위한 레벨업 난이도의 셔플안무
    
    ══
    
    본 행사에 많은 관심과 참여 부탁드립니다.
    
    감사합니다.
`,
    images: [Notice03Image01, Notice03Image02],
  },
  {
    id: "2",
    title: "『IPDIA KOREA 대전지부 오픈 기념 VLAZE 특별 워크샵』",
    date: "2025-03-06",
    detailText: `
🏅
IPDIA KOREA 국제실용댄스지도자협회
협회장 𝗩𝗟𝗔𝗭𝗘 𝗪𝗢𝗥𝗞𝗦𝗛𝗢𝗣

국제실용댄스지도자협회 대전지부,
투비셔플 TOBE SHUFFLE 설립을 기념하여
IPDIA KOREA 협회장 VLAZE 의 워크샵을
대전에서 진행합니다.

⏰7:00-8:00pm
📌[𝗪𝗢𝗥𝗞𝗦𝗛𝗢𝗣 𝟭 | 셔플&풋워크 비기너]
- 셔플 기초스텝을 배우고 계신 분들을 위한 셔플안무

⏰8:00-9:00pm
📌[𝗪𝗢𝗥𝗞𝗦𝗛𝗢𝗣 𝟮 | 셔플&풋워크 레벨업]
- 셔플 6개월 이상 경험자를 위한 레벨업 난이도의 셔플안무

2개의 난이도로 클래스가 준비되어 있어,
개인 실력에 맞게 VLAZE 협회장님 스타일의
셔플 안무를 제대로 배워보실 수 있습니다.

신청은 아래의 정보를 참고해주세요.

[신청 링크]
https://forms.gle/Vj8qvc5Um1d6WRyg9

[장소]
투비셔플 : 대전 유성구 은구비남로 41 502호

[수강료]
1 CLASS 40,000원

[문의]
010-2351-8784
`,
    images: [Notice02Image01, Notice02Image02],
  },
  {
    id: "1",
    title: "📌[셔플댄스 지도자 자격증 2급 2기 모집]",
    date: "2025-03-04",
    detailText: `
    IPDIA 국제실용댄스지도자협회 
📌[셔플댄스 지도자 자격증 2급 2기 모집]

IPDIA의 셔플댄스 지도자 자격증 과정은
신뢰할 수 있는 전문 풋워크 / 셔플 댄서 강사진이 직접 교육하며,
단순 이론이나 형식적인 자격 부여에 그치는 것이 아닌
차별화 된 커리큘럼과 실무중심의 트레이닝을 경험하실 수 있습니다.

체계적인 교육과정과 자격증 취득을 통해
경쟁력을 갖춘 전문인, 강사로 지금 도약해보세요!


📅 모집 기간 : 2월 8일 ~ 3월 8일
⏳ 교육 일정 : 3월 22일 개강 (매주 토요일 / 시간 별도 공지)
🔎 문의 및 신청
* 전화/문자 : 010-2351-8784, 010-7620-8784
* 카카오톡 : @넵튠댄스스튜디오
* IPDIA 서울본부 넵튠 댄스 스튜디오


[추천 대상]
▪ 댄스 강사 자격증 취득을 희망하는 분
▪ 전문적인 트레이닝을 통해 실력 향상을 목표로 하는 분
▪ 실무 중심의 교육으로 댄스 커리어를 확장하고 싶은 분

[신청 대상]
▪ IPDIA 본부센터 또는 지부 강사진 수업 40회 이상 수강자
▪ 타 댄스 자격증 소지자 또는 댄스 관련 직업인
▪ 셔플댄스 1년 이상 경력 보유자
※ 서류 심사 후 합격자는 교육 과정 합류 가능

[2급 교육 과정]
▪ 기간 : 8주
▪ 과정 : 교육 이수 후 자격 검정 응시 가능
`,
    images: [
      Notice01Image01,
      Notice01Image02,
      Notice01Image03,
      Notice01Image04,
      Notice01Image05,
      Notice01Image06,
    ],
  },
];
// E ::::: 공지사항 ::::: E

// 양식
// {
//   id: "",
//   title: "",
//   date: "",
//   detailText: `

// `,
//   images: [Notice04Image01, Notice04Image02],
// },
